<app-card
  class="flex-basis-100 mb-12"
  *ngIf="displayBuildingInfo(metadata) || displayBuildingInfo(originalMetadata)"
>
  <div cardTitle i18n>Informations sur le bâtiment</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.roomCount || originalMetadata?.roomCount"
      >
        <span class="card__label" i18n>Nombre de pièces</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.roomCount,
            }"
            >{{ metadata.roomCount }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.roomCount &&
              originalMetadata?.roomCount !== metadata.roomCount
            "
            >{{ originalMetadata.roomCount }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.buildingType || originalMetadata?.buildingType"
      >
        <span class="card__label" i18n>Type de bâtiment</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.buildingType,
            }"
            >{{ getBuildingTypeLabel(metadata.buildingType) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.buildingType &&
              originalMetadata?.buildingType !== metadata.buildingType
            "
            >{{ getBuildingTypeLabel(originalMetadata.buildingType) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.heatingSystem || originalMetadata?.heatingSystem"
      >
        <span class="card__label" i18n>Système de chauffage</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.heatingSystem,
            }"
            >{{ getHeatingSystemLabel(metadata.heatingSystem) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.heatingSystem &&
              originalMetadata?.heatingSystem !== metadata.heatingSystem
            "
            >{{ getHeatingSystemLabel(originalMetadata?.heatingSystem!) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.yearOfConstruction || originalMetadata?.yearOfConstruction
        "
      >
        <span class="card__label" i18n>Année de construction</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.yearOfConstruction,
            }"
            >{{ metadata?.yearOfConstruction }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.yearOfConstruction &&
              originalMetadata?.yearOfConstruction !==
                metadata.yearOfConstruction
            "
            >{{ originalMetadata?.yearOfConstruction }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.typeOfRoof || originalMetadata?.typeOfRoof"
      >
        <span class="card__label" i18n>Type de toit</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.typeOfRoof,
            }"
            >{{ getRoofTypeLabel(metadata?.typeOfRoof!) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.typeOfRoof &&
              originalMetadata?.typeOfRoof !== metadata.typeOfRoof
            "
            >{{ getRoofTypeLabel(originalMetadata?.typeOfRoof!) }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.sum || originalMetadata?.sum">
        <span class="card__label" i18n>Responsabilité civile</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.sum,
            }"
            >{{ metadata?.sum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.sum && originalMetadata?.sum !== metadata.sum
            "
            >{{ originalMetadata?.sum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.franchise || originalMetadata?.franchise"
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.franchise,
            }"
            >{{ metadata?.franchise }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.franchise &&
              originalMetadata?.franchise !== metadata.franchise
            "
            >{{ originalMetadata?.franchise }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.securityMeasures || originalMetadata?.securityMeasures"
      >
        <span class="card__label" i18n>Mesure de sécurité</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.securityMeasures,
            }"
            >{{ getSecurityMeasureLabel(metadata.securityMeasures) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.securityMeasures &&
              originalMetadata?.securityMeasures !== metadata.securityMeasures
            "
            >{{
              getSecurityMeasureLabel(originalMetadata.securityMeasures)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.sumInsured || originalMetadata?.sumInsured"
      >
        <span class="card__label" i18n>Somme assurée</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.sumInsured,
            }"
            >{{ metadata?.sumInsured }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.sumInsured &&
              originalMetadata?.sumInsured !== metadata.sumInsured
            "
            >{{ originalMetadata?.sumInsured }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.typeOfConstruction || originalMetadata?.typeOfConstruction
        "
      >
        <span class="card__label" i18n>Genre de construction</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.typeOfConstruction,
            }"
            >{{ getConstructionTypeLabel(metadata?.typeOfConstruction!) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.typeOfConstruction &&
              originalMetadata?.typeOfConstruction !==
                metadata.typeOfConstruction
            "
            >{{
              getConstructionTypeLabel(originalMetadata?.typeOfConstruction!)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.benefits || originalMetadata?.benefits"
      >
        <span class="card__label" i18n>Couvertures</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.benefits,
            }"
          >
            <ng-container
              *ngFor="let benefit of metadata?.benefits; let last = last"
              >{{ getCoverageTypeLabel(benefit)
              }}<ng-container *ngIf="!last">, </ng-container></ng-container
            >
          </span>
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              !compareArrays(metadata?.benefits!, originalMetadata?.benefits!)
            "
            ><ng-container
              *ngFor="
                let benefit of originalMetadata?.benefits;
                let last = last
              "
              >{{ getCoverageTypeLabel(benefit)
              }}<ng-container *ngIf="!last">, </ng-container></ng-container
            ></span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayComplementaryInfo(metadata) ||
    displayComplementaryInfo(originalMetadata)
  "
>
  <div cardTitle i18n>Informations complémentaires</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div class="card__row" *ngIf="metadata?.use || originalMetadata?.use">
        <span class="card__label" i18n
          >Est-il ou a-t-il par le passé été assuré pour les branches
          proposées ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.use,
            }"
            >{{ metadata?.use }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.use && originalMetadata?.use !== metadata.use
            "
            >{{ originalMetadata?.use }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.noOfTrade || originalMetadata?.noOfTrade"
      >
        <span class="card__label" i18n>Nombre d'étages ?</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.noOfTrade,
            }"
            >{{ metadata?.noOfTrade }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.noOfTrade &&
              originalMetadata?.noOfTrade !== metadata.noOfTrade
            "
            >{{ originalMetadata?.noOfTrade }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.noOfApartment || originalMetadata?.noOfApartment"
      >
        <span class="card__label" i18n>Nombre d'appartements</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.noOfApartment,
            }"
            >{{ metadata?.noOfApartment }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.noOfApartment &&
              originalMetadata?.noOfApartment !== metadata.noOfApartment
            "
            >{{ originalMetadata?.noOfApartment }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.commercialArea || originalMetadata?.commercialArea"
      >
        <span class="card__label" i18n>Zone commercial en m²</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.commercialArea,
            }"
            >{{ metadata?.commercialArea }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.commercialArea &&
              originalMetadata?.commercialArea !== metadata.commercialArea
            "
            >{{ originalMetadata?.commercialArea }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayQuestionnaire(metadata) || displayQuestionnaire(originalMetadata)
  "
>
  <div cardTitle i18n>Questionnaire</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.pastInsured !== null &&
            metadata?.pastInsured !== undefined) ||
          (originalMetadata?.pastInsured !== null &&
            originalMetadata?.pastInsured !== undefined)
        "
      >
        <span class="card__label" i18n
          >Est-il ou a-t-il par le passé été assuré pour les branches
          proposées ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.pastInsured === undefined ||
                  originalMetadata.pastInsured === null),
            }"
            >{{ getBooleanLabel(metadata?.pastInsured) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.pastInsured &&
              originalMetadata?.pastInsured !== metadata.pastInsured
            "
            >{{ getBooleanLabel(originalMetadata?.pastInsured) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.anyClaims !== null && metadata?.anyClaims !== undefined) ||
          (originalMetadata?.anyClaims !== null &&
            originalMetadata?.anyClaims !== undefined)
        "
      >
        <span class="card__label" i18n
          >A-t-il subi des sinistres dans les branches proposées ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.anyClaims === undefined ||
                  originalMetadata.anyClaims === null),
            }"
            >{{ getBooleanLabel(metadata?.anyClaims) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.anyClaims &&
              originalMetadata?.anyClaims !== metadata.anyClaims
            "
            >{{ getBooleanLabel(originalMetadata?.anyClaims) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.claimDetails || originalMetadata?.claimDetails"
      >
        <span class="card__label" i18n>Sinistres</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (!originalMetadata.claimDetails ||
                  originalMetadata.claimDetails?.length === 0),
            }"
            *ngFor="
              let detail of getBuildingClaimDetails(metadata.claimDetails)
            "
            >{{ detail }}</span
          >

          <ng-container
            *ngIf="originalMetadata && originalMetadata.claimDetails"
          >
            <span
              class="old-lead-value"
              *ngFor="
                let detail of getBuildingClaimDetails(
                  originalMetadata.claimDetails
                )
              "
              >{{ detail }}</span
            >
          </ng-container>
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.companyName || originalMetadata?.companyName"
      >
        <span class="card__label" i18n>Compagnie d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.companyName,
            }"
            >{{ metadata.companyName }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.companyName &&
              originalMetadata?.companyName !== metadata.companyName
            "
            >{{ originalMetadata.companyName }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.reason || originalMetadata?.reason"
      >
        <span class="card__label" i18n>Motif de cette conclusion</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.reason,
            }"
            >{{ metadata?.reason }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.reason &&
              originalMetadata?.reason !== metadata.reason
            "
            >{{ originalMetadata?.reason }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
